export default __webpack_public_path__ + "static/media/Retake-hero-poster.c47db054.jpg";